import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';
import { ContactFormM, ContactM } from '../utils/models';



@Injectable({
  providedIn: 'root',
})
export class ContactS {
  http = inject(HttpClient);
  url = `${environment.apiUrl}/Address`;

  // Cached version
  get(id: number = environment.companyCode): Observable<ContactM> {
    return this.http.get<ContactM>(`${this.url}/${id}`);
  }

  // Clear cache on update
  update(id: string, updateRequest: ContactM | FormData): Observable<ContactM> {
    return this.http.put<ContactM>(`${this.url}/${id}`, updateRequest);
  }
  
  // Send contact email
  sendContactEmail(contactData: ContactFormM): Observable<any> {
    return this.http.post(`/api/email/send-contact`, contactData);
  }
  
}
